<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-02-23 11:05:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-10-10 14:33:00
 * @FilePath: \qctsw-vue\packages\app\src\pages\news\author\[id].vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { APP_ROUTER, imageTransform } from '@qctsw/common'
import { contentRemoveTags, isClient } from '@qctsw/utils'
import { logicAuthorDetail } from '@/logic/news/author'
import { callWithNuxt } from '#app'

const nuxtApp = useNuxtApp()

const {
  id,
  page,
  state,
  authorData,
  pageData,
  pagination,
  getAuthorDetail,
  getAuthorArticleList,
} = logicAuthorDetail()

async function initHandler() {
  await getAuthorDetail()
  await callWithNuxt(nuxtApp, getAuthorArticleList, [page.value])
}

await initHandler()

function getMore() {
  getAuthorArticleList(pagination.value!.pagination.page++)
}
</script>

<template>
  <div bg-slate-1>
    <div class="public-container public-page flex">
      <div class="flex-grow min-w-0">
        <UtilLoadState :state="state" :reload-handler="initHandler">
          <template v-if="authorData">
            <div class="p-xl mb-lg flex bg-white rounded-md ">
              <NAvatar v-if="authorData.headImg" round :size="80" :src="imageTransform(authorData.headImg, { width: 160, height: 160 })" />
              <div v-else class="flex items-center justify-center w-20 h-20 rounded-full bg-blue-5 text-white text-10 font-bold">
                {{ authorData.authorName ? authorData.authorName?.slice(0, 1) : '无' }}
              </div>
              <div ml-xl>
                <h2 class="font-bold text-6 block">
                  {{ authorData.authorName }}
                </h2>
                <p v-if="authorData" class="text-4 text-slate-5 mt-sm">
                  作品：{{ authorData.articleCount ?? 0 }}
                </p>
              </div>
            </div>
            <div v-if="pagination" class="p-sm bg-white rounded-md">
              <UtilLoadState
                :length="pageData.length"
                type="up"
                :state="pagination?.pagination.status"
                :reload-handler="() => getAuthorArticleList(page)"
              >
                <template #loading>
                  <SkeletonArticle v-for="v in 10" :key="v" mb-sm />
                </template>
                <template v-if="pageData && pageData.length">
                  <baseList :state="pagination.pagination.status" @load="getMore">
                    <ArticleItem
                      v-for="(val, idx) in pageData" :key="idx"
                      :item="val" :show-author="false"
                      class="border-b-1 border-slate-1 py-sm"
                    />
                  </baseList>
                </template>
              </UtilLoadState>

              <!-- <BasicPagination
                v-if="pagination && pagination.pagination.pageCount"
                class="mt-sm"
                :page="pagination.pagination.page"
                :total="pagination.pagination.pageCount"
                :to="(page) => APP_ROUTER.authorDetail(id, { page })"
              /> -->
            </div>
          </template>
          <BasicEmpty v-else text="未找到相关媒体信息" />
        </UtilLoadState>
      </div>
      <div class="flex-shrink-0 w-[calc(100%-53rem)] pl-xl">
        <ClientOnly>
          <RankHotNews :embedded="false" class="mb-sm" />
          <RankAuthorCorrelation :embedded="false" class="sticky top-25" />
        </ClientOnly>
      </div>
      <UtilShareFixed />
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
